import React, { useState } from 'react';
import Breadcrumb from '../Breadcrumb';
import ServiceApplyBtn from '../../ui/ServiceApplyBtn';
import EvBag from "../../../assets/used-icons/EvBag.svg";
import EvGroup from "../../../assets/used-icons/EvGroup.svg";
import EvFour from "../../../assets/used-icons/EvFour.svg";
import EvTrade from "../../../assets/used-icons/EvTrade.png";
import EvBox from "../../../assets/used-images/EvBoxBg.png";
import IvoryList from "../../../assets/icons/IvoryGold.svg";
import { useTranslation } from 'react-i18next';

const Evaluate = () => {
  const { t } = useTranslation();

  const berkman = t('evaluate.berkman', { returnObjects: true });
  const talassure = t('evaluate.talassure', { returnObjects: true });

  const evaluates = [EvBag, EvTrade, EvGroup, EvFour];
  const [section, setSection] = useState({
    sec: berkman,
    id: 1
  });

  return (
    <>
      <Breadcrumb pages={[t('routes.services'), t('routes.evaluations')]} />
      <main className='container'>
        <div className='grid justify-items-center gap-3 relative border pt-4 px-4 rounded-xl pb-12'>
          <p className='services-header after:-bottom-1'>
            {t('routes.evaluations')}
          </p>
          <article className='text-semi-gray text-lg'>
            {t('evaluate.desc-one')}
          </article>
          <div className='flex gap-3 absolute text-lg -bottom-4 max-lg:text-base'>
            <button className={`${section.id === 1 ? 'text-white bg-secondary-tw' : 'bg-white text-secondary-tw'} w-60 py-1 rounded-lg border max-lg:w-auto max-lg:px-6`} onClick={() => setSection({ sec: berkman, id: 1 })}>
              {t('evaluate.berkman-ev')}
            </button>
            <button className={`${section.id === 2 ? 'text-white bg-secondary-tw' : 'bg-white text-secondary-tw'} w-60 py-1 rounded-lg border max-lg:w-auto max-lg:px-6`} onClick={() => setSection({ sec: talassure, id: 2 })}>
              {t('evaluate.talassure-ev')}
            </button>
          </div>
        </div>
        <main className='space-y-10'>
          <section className={`grid  gap-4 mt-10  max-lg:grid-cols-1 ${section.id === 1 ? 'grid-cols-5 max-xl:grid-cols-4' : 'grid-cols-4 max-xl:grid-cols-3'}`}>
            <div className='col-span-3 flex justify-center relative rounded-md max-lg:h-44 max-lg:col-span-1'>
              <img src={EvBox} alt="evaluate-img" className='w-full h-full object-cover rounded-md' />
              <div className='absolute top-8 max-lg:top-2 z-20 space-y-2 px-4'>
                <p className='text-secondary-tw text-xl'>
                  {section.sec?.title}
                </p>
                <p className='text-white text-lg max-lg:text-base' >
                  {section.sec?.desc}
                </p>
              </div>
              <div className='ev-box absolute z-0 rounded-md'></div>
            </div>
            {
              section?.sec?.details.map((detail, i) => (
                <div className='border p-4 text-center space-y-3 rounded-lg col-span-1' key={i}>
                  <p className='text-secondary-tw text-lg'>
                    {detail?.title}
                  </p>
                  <p>
                    {detail?.desc}
                  </p>
                </div>
              ))
            }
          </section>
          <div className='flex items-center justify-center gap-2'>
            <span>
              <img src={IvoryList} alt="ivory-list" className='!mb-4' />
            </span>
            <p className='text-lg font-bold'>
              {t('evaluate.ev-uses')}
            </p>
            <span className='rotate-180'>
              <img src={IvoryList} alt="ivory-list" className='!mt-4' />
            </span>
          </div>
          <div className={`grid justify-items-center gap-4 max-xl:grid-cols-2 max-lg:grid-cols-1 ${section.sec.evaluates.length <= 3 ? 'grid-cols-3' : 'grid-cols-4'} px-2`}>
            {
              section.sec?.evaluates?.map((ev, i) => (
                <div key={i} className='bg-primary-tw text-white border p-4 rounded-lg relative !text-start space-y-2'>
                  <span className='bg-secondary-tw flex justify-center items-center size-10 rounded-full absolute -top-4 -right-4'>
                    <img src={evaluates[i]} alt={ev?.title} className={`${ev?.icon?.includes('png') ? 'w-7' : 'w-6'}`} />
                  </span>
                  <p className='text-lg font-bold'>
                    {ev?.title}
                  </p>
                  <p className='text-gray-100 text-base' style={{ lineHeight: '20px' }}>
                    {ev?.desc}
                  </p>
                </div>
              ))
            }

          </div>
        </main>
      </main>

      <ServiceApplyBtn serviceId={2} serviceName={t('routes.evaluations')} />
    </>
  );
};

export default Evaluate;